import React, { useState } from 'react';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  entertainmentData,
  fashionShowData,
  promotionPartiesData,
  awardData,
  musicalNightData,
  adultPartyData,
  tradeShowData,
  thematicPartiesData,
  qawaliNightData,
  musicalCardData,
  fashionCardData,
  aperciationCardData,
  musicalNCardData,
  partyCardData,
  tradeCardData,
  themeCardData,
  qawaliCardData,
  promotionalCardData,
} from 'helpers/portfolioHelper';

const PrivateEvents = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'ENTERTAINMENT  EVENTS PORTFOLIO',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('Musical Concert');

  let [tabList] = useState([
    {
      id: 1,
      name: 'Musical Concert',
      active: true,
      component: (
        <TabsListing list={entertainmentData} cardData={musicalCardData} />
      ),
    },
    {
      id: 2,
      name: 'Fashion Shows',
      component: (
        <TabsListing list={fashionShowData} cardData={fashionCardData} />
      ),
    },
    {
      id: 3,
      name: 'Promotional Parties',
      component: (
        <TabsListing
          list={promotionPartiesData}
          cardData={promotionalCardData}
        />
      ),
    },
    {
      id: 4,
      name: 'Employee Apericiation',
      component: (
        <TabsListing list={awardData} cardData={aperciationCardData} />
      ),
    },
    {
      id: 5,
      name: 'Musical Night',
      component: (
        <TabsListing list={musicalNightData} cardData={musicalNCardData} />
      ),
    },
    {
      id: 6,
      name: 'Adult Parties',
      component: (
        <TabsListing list={adultPartyData} cardData={partyCardData} />
      ),
    },
    {
      id: 7,
      name: 'Trade Show',
      component: (
        <TabsListing list={tradeShowData} cardData={tradeCardData} />
      ),
    },
    {
      id: 8,
      name: 'Thematic Parties',
      component: (
        <TabsListing
          list={thematicPartiesData}
          cardData={themeCardData}
        />
      ),
    },
    {
      id: 9,
      name: 'Qawali Night',
      component: (
        <TabsListing list={qawaliNightData} cardData={qawaliCardData} />
      ),
    },
  ]);
  return (
    <section className='portfolioPage DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <CommonTab
          tabList={tabList}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
      </div>
    </section>
  );
};

export default SubPagesLayout({ route: 'portfolio/entertainment events' })(
  PrivateEvents
);
